import React from 'react';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from "../../../node_modules/@material-ui/core/FormControl/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Map from "./Map";
import FarmerInfoDialog from '../../components/FarmerInfoDialog.js';
import { FarmerCard, VoucherDialog, ExpendatureDialog } from '../../components/';

class Farmers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            allFarmers: [],
            allVouchers: [],
            locatedFarmers: [],
            viewRequest: false,
            farmerId: null,
            amount: 0,
            filteredFarmers: [],
            allFarmerVouchers: false,
            fullProfile: false,
            farmerProfile: [],
            produceFarming: [],
            checked: false,
            toggleExpense: false,
            selectedItem: "",
            allExpenses: [],
            loaded: false,
            switchDisplay: false,
            certification: "",
            produce: "",
            funding: "",
            landownership: "",
            searchName: ""
        };
        this.error = this.error.bind(this)
        this.successGetFarmers = this.successGetFarmers.bind(this)
        this.fundFarmerRequest = this.fundFarmerRequest.bind(this)
        this.submitFundFarmer = this.submitFundFarmer.bind(this)
        this.handleCancelDialog = this.handleCancelDialog.bind(this)
        this.processSuccessfulFunding = this.processSuccessfulFunding.bind(this)
        this.allFarmerVouchers = this.allFarmerVouchers.bind(this)
        this.successGetFarmerVouchers = this.successGetFarmerVouchers.bind(this)
        this.fundFarmerRequest = this.fundFarmerRequest.bind(this)
        this.voucherState = this.voucherState.bind(this)
        this.expenseRequest = this.expenseRequest.bind(this)
        this.checkchange = this.checkchange.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.filterFarmers = this.filterFarmers.bind(this)
        this.toggleMap = this.toggleMap.bind(this)
    }

    filterFarmers() {
        let toUse = this.state.allFarmers
        let self = this
        if (this.state.certification !== "") {
            toUse = toUse.filter(function (farmer) {
                return farmer.certification.toLowerCase().includes(self.state.certification.toLowerCase())
            })
        }
        if (this.state.funding !== "") {
            toUse = toUse.filter(function (farmer) {
                return farmer.fundingRequest.toLowerCase() === self.state.funding.toLowerCase()
            })
        }
        if (this.state.landownership !== "") {
            toUse = toUse.filter(function (farmer) {
                return farmer.landOwnership.toLowerCase() === self.state.landownership.toLowerCase()
            })
        }
        if (this.state.produce !== "") {
            toUse = toUse.filter(function (farmer) {
                return farmer.produceType.toLowerCase().includes(self.state.produce.toLowerCase())
            })
        }

        if (this.state.searchName !== "") {
            toUse = toUse.filter(function (farmer) {
                return (
                    farmer.name.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.surname.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.phone.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.email.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.username.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.farmName.toLowerCase().includes(self.state.searchName.toLowerCase())
                )
            })
        }
        let checker=this.state.switchDisplay
        if(checker){
            this.setState({
                filteredFarmers: toUse,
                switchDisplay:false
            },function () {
                self.setState({
                    switchDisplay:true
                })
            })
        }else{
            this.setState({
                filteredFarmers: toUse,
            })
        }
    }

    handleFilterChange(attr, value) {
        let self = this
        this.setState({
            [attr]: value
        }, function () {
            self.filterFarmers()
        })

    }

    toggleMap() {
        this.setState({
            switchDisplay: !this.state.switchDisplay
        })
    }

    handleCancelDialog(dialogName) {
        this.setState({
            [dialogName]: false,
            farmerId: null,
            amount: 0
        })
    }

    error(data) {
        console.log(data)
    }

    fullProfileRequest(farmerId, farmer) {

        this.setState({
            farmerId: farmerId,
            fullProfile: true,
            farmerProfile: farmer,
            produceFarming: farmer.produce_farming
        })
    }

    successGetFarmerVouchers(data) {
        this.setState({
            allVouchers: data.expenditure,
            allExpenses: data.expenditure
        })
    }


    expenseRequest() {
        // console.log(i)
        this.setState(state => ({
            toggleExpense: !state.toggleExpense,
            // selectedItem: i
        }))

    }

    fundFarmerRequest(farmerId, farmer) {
        this.setState({
            farmerId: farmerId,
            viewRequest: true,
            // farmerProfile:farmer,
        })
    }


    allFarmerVouchers(farmerId, farmer) {
        let self = this
        this.setState({
            farmerId: farmerId,
            allFarmerVouchers: true,
            farmerProfile: farmer
        }, function () {
            var data = {
                type: "getAllFundingExpenditurePerFarmer",
                farmerId: farmerId
            }
            Connections.performSecureRequest(data, self.successGetFarmerVouchers, self.error)
        })
    }

    successGetFarmers(data) {
        this.setState({
            allFarmers: data,
            filteredFarmers: data,
            loaded: true,
            locatedFarmers: data.filter(function (farmer) {
                return farmer.farmlatlong !== ""
            })
        })
    }

    componentDidMount() {
        var data = {
            "type": "admin_view_all_active_farmers",
        }
        Connections.performRequest(data, this.successGetFarmers, this.error)

    }

    processSuccessfulFunding(data) {
        alert("Funding successfully processed")
        this.handleCancelDialog("viewRequest")
    }

    submitFundFarmer() {
        if (this.state.amount < 10000) {
            alert("Amount to be funded should at least be R10000")
            return
        }
        let body = {
            type: "fundFarmer",
            amount: this.state.amount,
            farmerId: this.state.farmerId
        }
        Connections.performSecureRequest(body, this.processSuccessfulFunding, this.error)
    }

    checkchange() {

        this.setState({
            checked: true
        })
    }

    voucherState(state) {
        if (state === 1) {
            this.setState({
                voucherstate: "active"
            })
        }
        else if (state === 0) {
            this.setState({
                voucherstate: "not active"
            })
        }
    }

    render() {
        return (
            <DocumentTitle title="Khula - Favorite farmers">
                <div className="main-content">
                    <div>

                        <div className="col-sm-12 col-xs-12 col-lg-12 col-md-12"
                             style={{display: "flex", flexDirection: "row"}}>


                            <div className="input-group col-sm-3 col-xs-3 col-lg-3 col-md-3"
                                 style={{verticalAlign: "middle", paddingTop: "1rem"}}>
                                <input type="text" className="form-control" placeholder={"Search "+ this.state.allFarmers.length + " Farmers"}
                                       value={this.state.searchName}
                                       onChange={(e) => this.handleFilterChange("searchName", e.target.value)}/>
                            </div>

                            <div className="col-sm-9 col-xs-9 col-lg-9 col-md-9" style={{verticalAlign: "middle"}}>

                                <FormControl style={{marginRight: "1rem", width: "8rem", verticalAlign: "middle"}}>
                                    <InputLabel htmlFor="age-simple"
                                                style={{fontSize: "15px", fontWeight: "normal"}}>Ownership</InputLabel>
                                    <Select
                                        value={this.state.landownership}
                                        onChange={(e) => this.handleFilterChange("landownership", e.target.value)}
                                        // value={values.age}
                                        // onChange={handleChange}
                                        // inputProps={{
                                        //     name: 'age',
                                        //     id: 'age-simple',
                                        // }}
                                    >
                                        <MenuItem value="">None</MenuItem>
                                        <MenuItem value="own">Owned</MenuItem>
                                        <MenuItem value="leased">Leased</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl style={{marginRight: "1rem", width: "8rem", verticalAlign: "middle"}}>
                                    <InputLabel htmlFor="age-simple" style={{
                                        fontSize: "15px",
                                        fontWeight: "normal"
                                    }}>Certification</InputLabel>
                                    <Select

                                        value={this.state.certification}
                                        onChange={(e) => this.handleFilterChange("certification", e.target.value)}
                                        // inputProps={{
                                        //     name: 'age',
                                        //     id: 'age-simple',
                                        // }}
                                    >
                                        <MenuItem value="">None</MenuItem>
                                        <MenuItem value="global">Global Gap</MenuItem>
                                        <MenuItem value="local">Local Gap</MenuItem>
                                        <MenuItem value="pgs">PGS</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl style={{marginRight: "1rem", width: "8rem", verticalAlign: "middle"}}>
                                    <InputLabel htmlFor="age-simple" style={{fontSize: "15px", fontWeight: "normal"}}>Produce
                                        Type</InputLabel>
                                    <Select
                                        value={this.state.produce}
                                        onChange={(e) => this.handleFilterChange("produce", e.target.value)}
                                        // value={values.age}
                                        // onChange={handleChange}
                                        // inputProps={{
                                        //     name: 'age',
                                        //     id: 'age-simple',
                                        // }}


                                    >
                                        <MenuItem value="">None</MenuItem>
                                        <MenuItem value="veg">Veg</MenuItem>
                                        <MenuItem value="grain">Grain</MenuItem>
                                        <MenuItem value="poultry">Poultry</MenuItem>
                                        <MenuItem value="animal">Animal</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl style={{marginRight: "1rem", width: "8rem", verticalAlign: "middle"}}>
                                    <InputLabel htmlFor="age-simple" style={{fontSize: "15px", fontWeight: "normal"}}>Fund
                                        Request</InputLabel>
                                    <Select
                                        value={this.state.funding}
                                        onChange={(e) => this.handleFilterChange("funding", e.target.value)}
                                        // value={values.age}
                                        // onChange={handleChange}
                                        // inputProps={{
                                        //     name: 'age',
                                        //     id: 'age-simple',
                                        // }}
                                    >
                                        <MenuItem value="">None</MenuItem>
                                        <MenuItem value="yes">Yes</MenuItem>
                                        <MenuItem value="no">No</MenuItem>
                                    </Select>
                                </FormControl>


                                <div>
                                    <strong>{this.state.displayOrganic}</strong><br></br>
                                    <strong>{this.state.displayProduce}</strong><br></br>
                                    <strong>{this.state.displayDistance}</strong>
                                </div>
                            </div>
                            <div style={{display: "flex", justifyContent: "flex-end",paddingTop:"1rem"}}>
                                <input type="submit" value="Toggle Map" style={{
                                    margin: "1%",
                                    color: "green",
                                    borderColor: "green",
                                    fontFamily: "Roboto",
                                    fontSize: 11,
                                    height:30
                                }} onClick={() => this.toggleMap()}/>
                            </div>
                        </div>

                        {!this.state.switchDisplay &&

                        <div className="row">

                            {this.state.filteredFarmers.map((farmer,i) =>
                                <FarmerCard
                                    farmer={farmer}
                                    allFarmerVouchers={(id,farmer)=>this.allFarmerVouchers(id,farmer)}
                                    fullProfileRequest={(id,farmer)=>this.fullProfileRequest(id,farmer)}
                                    fundFarmerRequest={(id,farmer)=>this.fundFarmerRequest(id,farmer)}
                                    key={i}
                                />
                            )}


                        </div>
                        }

                    </div>

                    {this.state.switchDisplay && <Map data={this.state.filteredFarmers}/>}
                    <FarmerInfoDialog
                        open={this.state.fullProfile}
                        handleCancelDialog={(item) => this.handleCancelDialog(item)}
                        farmerImages={this.state.farmerImages}
                        farmerProfile={this.state.farmerProfile}
                        produceFarming={this.state.produceFarming}
                        farmerId={this.state.farmerId}
                        fundFarmerRequest={(id)=>this.fundFarmerRequest(id)}
                    />
                    
                    <VoucherDialog
                        farmerProfile={this.state.farmerProfile}
                        amount={this.state.amount}
                        dialogOpen={this.state.viewRequest}
                        onAmountChange={(amount) => this.setState({
                            amount
                        })}
                        onSubmitFundFarmer={()=>this.submitFundFarmer()}
                        onCancel={()=>this.handleCancelDialog("viewRequest")}
                    />

                    <ExpendatureDialog
                        dialogOpen={this.state.allFarmerVouchers}
                        farmerProfile={this.state.farmerProfile}
                        vouchers={this.state.allVouchers}
                        onCancel={()=>this.handleCancelDialog("allFarmerVouchers")}
                    />

                </div>

            </DocumentTitle>
        );
    }

}


export default Farmers;



// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/AllFarmers.js